const calendar = {
  resetToToday({ commit }) {
    commit('resetStartDate');
    commit('resetEndDate');
  },
  incrementDateRange({ commit }) {
    commit('incrementStartDate');
    commit('incrementEndDate');
  },
  decrementDateRange({ commit }) {
    commit('decrementEndDate');
    commit('decrementStartDate');
  },
};

const actions = {
  bulkSetTempState({ commit }, payload) {
    for (let key in payload) {
      commit('setTempState', {
        path: key,
        value: payload[key]
      });
    }
  },
  ...calendar,
};

export default actions;
